import { faTrash } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import CopyToClipboard from 'components/CopyToClipboard';
import AccessResource from 'models/access/resource';
import React, { useContext, useMemo } from 'react';
import { Link } from 'react-router-dom';
import * as Contexts from './Context';

type Props = {
  value: AccessResource
};

export const AccessRow = ({ value }: Props) => {
  const { selection, setSelection } = useContext(Contexts.SelectionContext);

  const uploadLink = useMemo(() => `${window.location.origin}/upload/${value.token}`, [value.token]);

  return (
    <tr>
      <td><Link to={`/admin/uploads/${value.token}`}>{value.company}</Link></td>
      <td>
        {value.token}
        {' '}
        <CopyToClipboard title="Kopier link" value={uploadLink} />
      </td>
      <td>
        <button
          type="button"
          className="blank-button"
          onClick={() => setSelection({ ...selection, deleting: value })}
        >
          <FontAwesomeIcon icon={faTrash} />
        </button>
      </td>

    </tr>
  );
};
export default AccessRow;
